// HTML модалки (как строка)
const callbackModalHTML = `
<div class="callback__modal">
    <svg data-ym-goal="close_modal_form" class="callback__modal__close" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 2L17 17" stroke="white" stroke-width="4" />
        <path d="M17 2L2 17" stroke="white" stroke-width="4" />
    </svg>

    <p class="callback__modal__text">
        Запишись <br> <span>на бесплатный урок</span> и прочувствуй <span>вайб <svg width="75" height="6" viewBox="0 0 75 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 3.50012C22.0022 2.87275 62.6741 2.47734 73.9999 3.00015" stroke="#5C8AFF" stroke-width="4" />
            </svg>
        </span> <br> <span>нашей подготовки <svg width="252" height="9" viewBox="0 0 252 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M251.5 7C170.5 -1 80.965 3.15679 57.4766 3.78416C33.9882 4.41154 1 5.5 1 5.5" stroke="#5C8AFF" stroke-width="4" />
            </svg>
        </span>
    </p>
    <div class="callback__form">
        <form>
            <input
                name="name"
                placeholder="Имя"
                required
                type="text" />
            <div class="custom__select" data-select>
                <button class="custom__select__btn" type="button" data-select-btn>
                    <p class="select-label" data-select-label>Класс</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="9" viewBox="0 0 15 9" fill="none">
                        <path d="M14.0703 1L7.57031 7L1.07031 1" stroke="#A9A9A9" stroke-width="2" />
                    </svg>
                </button>
                <ul class="custom__select__dropdown" data-select-dropdown>
                   <li data-value="11">11 (Сдаю ЕГЭ 2025)</li>
                <li data-value="10">10 (Сдаю ЕГЭ 2026) </li>
                <li data-value="9">9 (Сдаю ОГЭ 2025)</li>
                <li data-value="8">8 класс</li>
                <li data-value="7">7 класс</li>
                </ul>
                <input type="hidden" name="class" data-select-input>
            </div>
            <input
                name="phone"
                placeholder="Телефон"
                required
                type="tel" />
            <input type="hidden" class="ym-client-id" name="ym_client_id" value="">
            <button class="callbackForm__submit btn-clrd orange" data-ym-goal="submit_modal_form">
                Записаться на урок
            </button>
            <input type="hidden" name="form_id" value="callback-modal">
            <a href="#" class="callback__form__policy">Нажимая кнопку, я соглашаюсь на&nbsp;обработку персональных данных</a>
        </form>


    </div>
</div>
`;

// ДОБАВИТЬ ИМПОРТЫ
import { initCustomSelects, initPhoneMask } from "../../forms/main-page/form";

// Открытие модалки по делегированию (работает для асинхронных элементов)
document.addEventListener("click", (e) => {
  const target = e.target as HTMLElement;
  const actionBtn = target.closest('[data-action="callback-modal"]');
  if (actionBtn) {
    e.preventDefault();
    const modal = document.querySelector(".modal");
    const modalContent = modal?.querySelector(".modal__content");
    if (modal && modalContent) {
      // Сохраняем оригинальное содержимое, если еще не сохранено

      modalContent.innerHTML = callbackModalHTML;
      modal.classList.add("open");
      modal.classList.add("callback-wrapper");

      // Инициализируем кастомный select и маску телефона только внутри модалки
      initCustomSelects(modalContent as HTMLElement);
      initPhoneMask(modalContent as HTMLElement);

      // Инициализируем отправку формы для формы внутри модалки
      const modalForm = modalContent.querySelector("form");
      if (modalForm) {
        // Сбрасываем флаг, чтобы обработчик навесился заново
        delete (modalForm as any)._hasSubmitHandler;
      }
      // Ждём появления initFormSubmit в window, если её ещё нет
      function waitForInitFormSubmit(attempt = 0) {
        if (typeof (window as any).initFormSubmit === "function") {
          (window as any).initFormSubmit(modalContent as HTMLElement);
        } else if (attempt < 10) {
          setTimeout(() => waitForInitFormSubmit(attempt + 1), 50);
        } else {
          console.error("initFormSubmit не определена в window");
        }
      }
      waitForInitFormSubmit();

      // Функция для закрытия модалки и возврата оригинального содержимого
      const closeModal = () => {
        modal.classList.remove("open");
        setTimeout(() => {
          modal.classList.remove("callback-wrapper");
        }, 400);
        if ((modal as any)._originalContent) {
          modalContent.innerHTML = (modal as any)._originalContent;
        }
      };

      // Навешиваем обработчик на крестик
      const closeBtn = modalContent.querySelector(".callback__modal__close");
      if (closeBtn) {
        closeBtn.addEventListener("click", closeModal);
      }

      // Добавляем обработчик на подложку для закрытия по клику вне modal__content
      modal.addEventListener(
        "click",
        (event) => {
          // Если клик был именно по подложке (а не по содержимому)
          if (event.target === modal) {
            closeModal();
          }
        },
        { once: true }
      );
    }
  }
});
